import AttachMoney from '@material-ui/icons/AttachMoney';
import moment from 'moment';
import React from "react";

import Content from "../../../shared/NotificationsDrawer/NotificationViewTab/partials/Content";
import Subheader from "../../../shared/NotificationsDrawer/NotificationViewTab/partials/Subheader";

import withNotificationMarkedRead from "./withNotificationMarkedRead";

function AgencyIncentiveUpdated({
  notification: {
    attributes: { createdAt, messageBody },
  },
  jobcast: {
    attributes: {
      individualAvatar,
      individualFirstName,
      individualLastInitial,
      organizationName,
    }
  }
}) {
  return (
    <div>
      <Subheader
        leftChip={{
          chipHeader: "Update from",
          individualFirstName,
          individualLastInitial,
          individualAvatar,
          chipSubText: organizationName,
        }}
      />
      <Content
        iconImage={AttachMoney}
        iconCaption="Agency Incentive Updated"
        label="Agency Incentive Updated"
        value={messageBody}
        helperText={moment(createdAt).format("MMMM Do, YYYY")}
      />
    </div>
  );
}

export default withNotificationMarkedRead(AgencyIncentiveUpdated);
